<template>
	<div class="app-more" name="app_more" id="app_more">
		<div v-for="item in appMore" :key="item.title" :class="item.class">
			<div class="am-block dp-f">
				<div class="block-content">
					<h3 class="block-title">{{ item.title }}</h3>
					<p class="block-subtitle">{{ item.subTitle }}</p>
					<ul class="block-use nutstore1">
						<li
							:style="generateStyle(item.icons1, index)"
							v-for="(text, index) in item.texts1"
							:key="text"
						>
							{{ text }}
						</li>
					</ul>
				</div>
				<img class="block-pic" :src="item.src1 || pic1" alt />
			</div>
			<div class="am-block dp-f reverse">
				<img class="block-pic" :src="item.src2 || pic2" alt />
				<div class="block-content">
					<ul class="block-use nutstore2">
						<li
							:style="generateStyle(item.icons2, index)"
							v-for="(text, index) in item.texts2"
							:key="text"
						>
							{{ text }}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import pic1 from './icon/nutstore-1-pic.svg'
import pic2 from './icon/nutstore-2-pic.svg'

export default {
	props: {
		appMore: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			pic1,
			pic2,
		}
	},
	methods: {
		generateStyle(icons, index) {
			return icons && icons[index]
				? { backgroundImage: `url(${icons[index]})` }
				: {}
		},
	},
}
</script>
<style lang="scss" scoped>
.app-more {
	.am-block {
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		padding-top: 120px;
	}
	.am-block.reverse {
		flex-wrap: wrap-reverse;
	}
	.block-content {
		margin: 0 20px 0;
	}
	.block-pic {
		margin: 0 20px 0;
		width: 500px;
		height: 304px;
	}
	.block-use {
		li {
			line-height: 24px;
			margin-top: 28px;
			font-size: 14px;
			color: #575757;
			max-width: 460px;
			padding-left: 40px;
			// background: url('../images/svg/more-icon-platform.svg') 0 center/24px 24px no-repeat;
		}
	}
	.block-use.nutstore1 {
		li:nth-child(1) {
			background: url('./icon/nutstore-1-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(2) {
			background: url('./icon/nutstore-2-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(3) {
			background: url('./icon/nutstore-3-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(4) {
			background: url('./icon/nutstore-4-icon.svg') 0 center/24px 24px no-repeat;
		}
	}
	.block-use.nutstore2 {
		li:nth-child(1) {
			background: url('./icon/nutstore-5-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(2) {
			background: url('./icon/nutstore-6-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(3) {
			background: url('./icon/nutstore-7-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(4) {
			background: url('./icon/nutstore-8-icon.svg') 0 center/24px 24px no-repeat;
		}
		li:nth-child(5) {
			background: url('./icon/nutstore-9-icon.svg') 0 center/24px 24px no-repeat;
		}
	}
	.block-title {
		font-size: 32px;
		color: #3f4657;
	}
	.block-subtitle {
		margin-top: 24px;
		font-size: 16px;
		color: #6d6d6d;
	}
}

@media (max-width: 414px) {
	.app-more {
		.block-pic {
			margin-top: 32px;
			width: 300px;
		}
		.block-content {
			margin-top: 32px;
		}
	}
}
</style>
